import { DocumentRetrievalLocationStatus, DocumentRetrievalTaskSource } from "healthex-common/document.retrieval.dtos";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
const isParticleLocationSource = (source) => source === DocumentRetrievalTaskSource.PARTICLE_EPIC || source === DocumentRetrievalTaskSource.PARTICLE_FASTEN;
export function logLocationSecondaryLabelDisplay(location, needsAuth, hideNewProviderLabel) {
    if (needsAuth) {
        console.log("[Document Retrieval] LocationSecondaryLabel displayed", {
            locationKey: location.key,
            locationName: location.name,
            displayType: "skipped_needs_auth",
            displayText: t("Skipped, log in to access"),
            source: location.source,
            status: location.status,
        });
        return;
    }
    if (isParticleLocationSource(location.source) && location.status === DocumentRetrievalLocationStatus.NEEDS_AUTH) {
        console.log("[Document Retrieval] LocationSecondaryLabel displayed", {
            locationKey: location.key,
            locationName: location.name,
            displayType: "particle_needs_auth",
            displayText: t("You may have records here"),
            source: location.source,
            status: location.status,
        });
        return;
    }
    if (location.addedBy && !hideNewProviderLabel) {
        console.log("[Document Retrieval] LocationSecondaryLabel displayed", {
            locationKey: location.key,
            locationName: location.name,
            displayType: "new_provider",
            displayText: t("New provider"),
            source: location.source,
            status: location.status,
            addedBy: location.addedBy,
        });
        return;
    }
    console.log("[Document Retrieval] LocationSecondaryLabel not displayed", {
        locationKey: location.key,
        locationName: location.name,
        needsAuth,
        hideNewProviderLabel,
        source: location.source,
        status: location.status,
        addedBy: location.addedBy,
    });
}
